import { render, staticRenderFns } from "./UiAlertStrip.vue?vue&type=template&id=3ca00068&"
import script from "./UiAlertStrip.vue?vue&type=script&lang=js&"
export * from "./UiAlertStrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports